import { colors as palette } from '@veracity/vui'

export const chartMarkerColors = {
  red: palette.energyRed.main,
  darkRed: palette.energyRed[35],
  purple: '#9467bd',
  darkPurple: '#5e03af',
  blue: palette.seaBlue.main,
  skyBlue: palette.skyBlue.main,
  darkBlue: palette.darkBlue.main,
  yellow: palette.sunflower.main,
  orange: palette.earth.main,
  darkOrange: palette.terracotta.main,
  black: '#000000',
  green: palette.digiGreen.main,
  darkGreen: palette.landGreen.main,
  gray: palette.sandstone.main,
  darkGray: palette.warmGrey.main
}
